
<div [hidden]="hideelemet">
  <span class="dot" id="{{data}}" [ngStyle]="{'background-color':colorcode}">
  </span>
  {{data}}
</div>


